const HANDLESUBMIT = {
  data() {
    return {
      formComplete: false,
      wasValidated: false,
      dateOfBirth: '',
      isUnder8: false,
      isUnder13: false,
      isUnder17: false,
      isUnder18: false,
      isUnder21: false,
      isOver55: false,
      password: {
        password: '',
        confirmPassword: ''
      },
      confirmRequired: false
    }
  },
  methods: {
    handleSubmit() {
      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.getElementsByClassName('needs-validation')
      const submitButtons = document.querySelectorAll('button[type=submit]')
      // Loop over them and prevent submission
      Array.prototype.filter.call(forms, (form) => {
        form.addEventListener('submit', (event) => {
          submitButtons.forEach((element) => {
            if (typeof element !== 'undefined') {
              element.setAttribute('disabled', '')
            }
          })
          if (form.checkValidity() === false) {
            event.preventDefault()
            event.stopPropagation()
            this.formComplete = false
            submitButtons.forEach((element) => {
              if (typeof element !== 'undefined') {
                element.removeAttribute('disabled')
              }
            })
            const firstInvalid = form.querySelector(':invalid')
            if (firstInvalid) {
              firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          } else {
            this.formComplete = true
          }
          if (this.password.password !== this.password.confirmPassword) {
            this.password.confirmPassword = ''
            this.formComplete = false
            submitButtons.forEach((element) => {
              if (typeof element !== 'undefined') {
                element.removeAttribute('disabled')
              }
            })
          }
          this.wasValidated = true
          form.classList.add('was-validated')
        }, false)

        form.addEventListener('input', () => {
          submitButtons.forEach((element) => {
            if (typeof element !== 'undefined') {
              element.removeAttribute('disabled')
            }
          })
        })
      })
    },
    checkValidity() {
      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.getElementsByClassName('needs-validation')
      // Loop over them and prevent submission
      Array.prototype.filter.call(forms, (form) => {
        if (form.checkValidity() === false) {
          event.stopPropagation()
          this.formComplete = false
        } else {
          this.formComplete = true
        }
        if (this.password.password !== this.password.confirmPassword) {
          this.password.confirmPassword = ''
          this.formComplete = false
        }
        this.wasValidated = true
        form.classList.add('was-validated')
      })
    },
    removeValidation() {
      const forms = document.getElementsByClassName('needs-validation')
      Array.prototype.filter.call(forms, (form) => {
        this.wasValidated = false
        form.classList.remove('was-validated')
      })
    },
    resetForm() {
      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.getElementsByClassName('needs-validation')
      Array.prototype.filter.call(forms, (form) => {
        form.classList.remove('was-validated')
      })
      this.formComplete = false
    },
    today() {
      // Get today's date for date field's "max" attribute
      let today = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date()
      let dd = today.getDate()
      let mm = today.getMonth() + 1
      const yyyy = today.getFullYear()
      if (dd < 10) {
        dd = `0${dd}`
      }
      if (mm < 10) {
        mm = `0${mm}`
      }
      today = `${yyyy}-${mm}-${dd}`
      return today
    }
  },
  watch: {
    dateOfBirth(birth) {
      // When Date Of Birth is changed, determine if they're under 18
      if (birth !== '' && birth !== null) {
        const record = new Date(birth.trim())
        const day = record.getDate()
        const month = record.getMonth()
        const year = record.getFullYear()
        const today = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date()
        this.isUnder8 = new Date(year + 8, month, day) >= today
        this.isUnder13 = new Date(year + 13, month, day) >= today
        this.isUnder17 = new Date(year + 17, month, day) >= today
        this.isUnder18 = new Date(year + 18, month, day) >= today
        this.isUnder21 = new Date(year + 21, month, day) >= today
        this.isOver55 = new Date(year + 55, month, day) <= today
      } else if (birth === '') {
        this.isUnder8 = true
        this.isUnder13 = true
        this.isUnder17 = true
        this.isUnder18 = true
        this.isUnder21 = true
        this.isOver55 = false
      }
    },
    password: {
      handler(password) {
        this.confirmRequired = password.password.length > 0 ? true : false
      },
      deep: true
    }
  }
}

export default HANDLESUBMIT



// WEBPACK FOOTER //
// ./src/mixins/formValidation.js